require('select2');

$('.select-multiple').select2({
    placeholder: "Select one or multiple option(s)",
});